import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TranslateService } from "@ngx-translate/core";
import { Subject, Subscription, takeUntil } from 'rxjs';
import { VenueService } from '../pos-panel/services/venues/venue.service';
import { DropdownHelperModel } from '../pos-panel/models/helpers/dropdown-helper.model';
import { RoleNameEnum } from "../admin-panel/enums/role-name.enum";
import { UserModel } from "../share-modul/models/user/user.model";
import { AuthenticationService } from "../share-modul/services/authentication/authentication.service";
import { CurrentVenueHelperService } from "../share-modul/services/current-venue-helper/current-venue.helper.service";
import {  ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-pos-navbar',
  templateUrl: './pos-navbar.component.html',
  styleUrls: ['./pos-navbar.component.scss']
})
export class PosNavbarComponent implements OnInit, OnDestroy {


  public menuOptions: any[];
  public menuOptionsIn: any[];
  public items: MenuItem[];
  public venueIdUpdateSubscription: Subscription;
  public currentVenueId: string | null;
  public employeeItems: MenuItem[];
  public inventoryItems: MenuItem[];
  public unsubscribe: Subject<void> = new Subject<void>()
  public venues: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public imagePath: string = './assets/images/logo/shop icon.png';
  public user: UserModel | null;
  public inMenu: boolean = false;
  public currentVenue: any;

  constructor(
    public _router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public venueService: VenueService,
    public messageService: MessageService,
    public authenticationService: AuthenticationService,
    public currentVenueHelper: CurrentVenueHelperService
  ) {
  }

  ngOnInit(): void {
    this.authenticationService.loginUser.asObservable().subscribe(user => this.user = user);
    this.venueIdUpdateSubscription = this.currentVenueHelper.onUpdateRoute().subscribe(currentVenueId => {
      if(currentVenueId !== null){
        if (this.venues.length == 0){
          if (!this.user?.roles.includes(RoleNameEnum.PosGeneralManager)) {
              this.getAllVenuesForMNG(currentVenueId);       
            } else {
              this.getAllVenuesForGMN(currentVenueId); 
            } 
        } else {
          this.currentVenue = currentVenueId != undefined && this.venues.filter(venue => venue.id == currentVenueId).length > 0 ? this.venues.filter(venue => venue.id == currentVenueId)[0].id : this.venues[0].id.toString();
        }
      }
    })
    
  }

  getAllVenuesForGMN(currentVenueId?: string | null |undefined) {
    this.venues = new Array<DropdownHelperModel>();

    this.venueService.listallgmnvenuesforcombo()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.venues = response;
          if(this.venues.length > 0){
              this.currentVenue = currentVenueId != undefined && this.venues.filter(venue => venue.id == currentVenueId).length > 0 ? this.venues.filter(venue => venue.id == currentVenueId)[0].id : this.venues[0].id.toString();
              if(currentVenueId == undefined){
                this._router.navigate([this.currentVenue.toString().concat(this._router.routerState.snapshot.url.toString())])
              }
              if(currentVenueId != undefined && this.venues.filter(venue => venue.id == currentVenueId).length == 0){
                let subRoute = this._router.routerState.snapshot.url.toString().substring(1);
                this._router.navigate([this.currentVenue.toString(),subRoute.substring(subRoute.indexOf('/')+1)])
              }
          }else{
            this._router.navigate(['no-venues']);
          }
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  };

  getAllVenuesForMNG(currentVenueId?: string | null | undefined) {
    this.venues = new Array<DropdownHelperModel>();

    this.venueService.listallmngvenuesforcombo()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.venues = response;
          if(this.venues.length > 0){
            this.currentVenue = currentVenueId != undefined && this.venues.filter(venue => venue.id == currentVenueId).length > 0 ? this.venues.filter(venue => venue.id == currentVenueId)[0].id : this.venues[0].id.toString();
            if(currentVenueId == undefined){
              this._router.navigate([this.currentVenue.toString().concat(this._router.routerState.snapshot.url.toString())])
              }
              if(currentVenueId != undefined && this.venues.filter(venue => venue.id == currentVenueId).length == 0){
                let subRoute = this._router.routerState.snapshot.url.toString().substring(1);
                this._router.navigate([this.currentVenue.toString(),subRoute.substring(subRoute.indexOf('/')+1)])
              }
          }else{
            this._router.navigate(['no-venues']);
          }
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  };

  isUserGeneralManager(): boolean | undefined {
    return this.user?.roles.includes(RoleNameEnum.PosGeneralManager);
  }

  openWaiterSection(){
    this._router.navigate(["waiter"])
  }


  ngOnDestroy(): void {
    this.currentVenueHelper.resetCurrentVenueIdDropdown();
    this.currentVenueHelper.resetTimezone();

    if(this.venueIdUpdateSubscription){
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
